<template>
	<v-row class="cl-fields">
		<v-col v-for="(modello, nome) in chiavi" :key="nome" cols="12" :md="info(nome).largo ? 12 : 6">
			<div class="d-flex align-center">
				<v-text-field
					v-model="valori[nome]"
					:label="info(nome).label"
					:placeholder="info(nome).placeholder"
					:hint="info(nome).hint"
					:persistent-hint="!!info(nome).hint"
					:prepend-inner-icon="info(nome).icona"
					outlined
					dense
					:hide-details="!info(nome).hint"
					class="flex-grow-1"
				/>
				<v-btn v-if="caricabili.includes(nome)" small outlined color="primary" class="ml-2 cl-up" @click="$emit('carica', nome)"><v-icon left small>mdi-upload</v-icon>Carica</v-btn>
			</div>
			<img v-if="caricabili.includes(nome) && valori[nome]" :src="valori[nome]" alt="" class="cl-preview" />
		</v-col>
	</v-row>
</template>

<script>
// campi chiave/valore della configurazione (SEO, link social): etichette leggibili al posto dei nomi tecnici
export default {
	name: 'CampiLink',
	props: {
		// oggetto da modificare (es. form.layout.seo)
		valori: { type: Object, required: true },
		// oggetto modello: le sue chiavi sono i campi mostrati, nell'ordine
		chiavi: { type: Object, required: true },
		// { chiave: { label, icona, placeholder, hint, largo } }
		etichette: { type: Object, default: () => ({}) },
		// chiavi con il pulsante Carica (immagini)
		caricabili: { type: Array, default: () => [] },
	},
	methods: {
		info(nome) {
			return this.etichette[nome] || { label: nome };
		},
	},
};
</script>

<style scoped>
.cl-fields {
	margin: 0;
}
.cl-fields > [class*='col'] {
	padding: 6px;
}
.cl-up {
	height: 40px !important;
}
.cl-preview {
	display: block;
	max-height: 48px;
	max-width: 160px;
	margin-top: 6px;
	border: 1px solid #e1e7ef;
	border-radius: 6px;
	padding: 2px;
	background: #fff;
}
</style>
